export const RE_CHANGE_MESSAGE = 'RE_CHANGE_MESSAGE';
export const RE_UPDATE_MODEL_STATUS = 'RE_UPDATE_MODEL_STATUS';
